import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from '@angular/core';
import { ButtonComponent } from '@lyceo/shared/ui';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import {
  faPenToSquare,
  IconDefinition,
} from '@fortawesome/pro-solid-svg-icons';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'homi-data-list',
  templateUrl: 'data-list.component.html',
  styleUrls: ['data-list.component.scss'],
  imports: [ButtonComponent, FaIconComponent, TranslocoDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataListComponent {
  public readonly editable: InputSignal<boolean> = input(true);
  public readonly edit: OutputEmitterRef<void> = output();

  protected readonly faPenToSquare: IconDefinition = faPenToSquare;
}
